import $ from 'jquery';

// Custom dropdowns
$(function() {

  const dropdowns = document.querySelectorAll('.dropdown');
  dropdowns.forEach(elem => {

    // Dropdown elements
    const dropdownInput = elem.querySelector('input');
    const dropdownLabel = elem.querySelector('.dropdown__label-text');

    // Open
    elem.addEventListener('click', (event) => {
        if (!event.target.classList.contains('dropdown__item')) {
            elem.classList.toggle('active');
        }
    });

    // Select item
    elem.querySelectorAll('.dropdown__item').forEach(option => {
        option.addEventListener('click', (event) => {

            // Update Input
            dropdownInput.value = event.target.dataset.value;
            dropdownLabel.textContent = event.target.innerHTML;
            elem.classList.remove('active');

            // Dispatch custom updated event
            const updateEvent = new CustomEvent('dropdown-update', { bubbles: true, detail: dropdownInput.value });
            option.dispatchEvent(updateEvent);

        });
    });

  });

});